/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FlyingRoger/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FlyingRoger({
  children,
  viewPath = "/DesignSystem/Images/FlyingRoger",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 1162,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 360
  
}) {
  return (<React.Fragment
>
<img
  data-testid="FlyingRoger.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Zxae0n': alignSelf,'--bc-2-Zxae0n': backgroundColor,'--bblr-3-Zxae0n': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Zxae0n': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Zxae0n': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Zxae0n': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Zxae0n': typeof height === 'number' ? `${height}px` : height,'--mb-8-Zxae0n': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Zxae0n': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Zxae0n': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Zxae0n': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Zxae0n': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}